// Components==============
import React, { useContext } from 'react';
import { loginContext } from '../Login';
import './Top.module.scss';
// =========================

export default function Top({ loginFailed }: { loginFailed: boolean }) {
    const { setUsername, username, setPassword, setLoginFailed } = useContext(
        loginContext
    );

    return (
        <div styleName="top">
            <img src="/images/spiekdigitaal.svg" alt="spiek digitaal" />
            <p>
                Welkom bij Spiek Digitaal! Log hieronder in met jouw voornaam,
                wachtwoord en avatar.
            </p>
            {loginFailed && (
                <p styleName="error">
                    <strong>
                        Helaas, deze gegevens kloppen niet. Probeer het nog een
                        keer!
                    </strong>
                </p>
            )}
            <div styleName="inputs-wrapper">
                <input
                    onChange={(event) => {
                        setLoginFailed(false);
                        setUsername(event.target.value);
                    }}
                    value={username}
                    placeholder="Voornaam"
                />
                <input
                    type="password"
                    onChange={(event) => {
                        setLoginFailed(false);
                        setPassword(event.target.value);
                    }}
                    placeholder="Wachtwoord"
                />
            </div>
        </div>
    );
}
